export default __webpack_public_path__ + "static/media/noa-10.7f006ae3.jpg";